var map = {
	"./address_image.svg": 129,
	"./animated_ashutosh.png": 130,
	"./animated_logo.svg": 131,
	"./aws_logo.jpeg": 132,
	"./aws_logo.png": 133,
	"./bdmi_logo.png": 134,
	"./blogs_image.svg": 135,
	"./bluestock_logo.jpeg": 136,
	"./cloud_infrastructure.svg": 137,
	"./codeInLogo.png": 138,
	"./contactMail.png": 139,
	"./coursera_logo.png": 140,
	"./data_science.svg": 141,
	"./deeplearning_ai_logo.png": 142,
	"./delhivery_logo.png": 143,
	"./developerActivity.svg": 144,
	"./dsc_logo.png": 145,
	"./eazybyts_logo.png": 146,
	"./education.svg": 147,
	"./experience.svg": 148,
	"./feelingProud.svg": 149,
	"./freecopy_logo.png": 150,
	"./fullstack.svg": 151,
	"./gcp_logo.png": 152,
	"./github_logo.png": 153,
	"./googleAssistant.jpg": 154,
	"./googleAssistant.svg": 155,
	"./google_logo.png": 156,
	"./ibm_logo.png": 157,
	"./iiitk_logo.png": 158,
	"./intel_logo.jpg": 159,
	"./iu_logo.png": 160,
	"./jsFramework.svg": 161,
	"./legato_logo.png": 162,
	"./manOnTable.svg": 163,
	"./microsoft_logo.png": 164,
	"./mozilla_logo.png": 165,
	"./muffito_logo.png": 166,
	"./nextuLogo.jpg": 167,
	"./nptel_logo.png": 168,
	"./nsec_logo.jpeg": 169,
	"./nsec_logo.png": 170,
	"./portfolio.gif": 171,
	"./programmer.svg": 172,
	"./projects_image.svg": 173,
	"./pwa.png": 174,
	"./saayaHealthLogo.png": 175,
	"./stanford_logo.png": 176,
	"./sugata_chanda.jpeg": 177,
	"./sugata_chanda.pdf": 178,
	"./sugata_logo.gif": 179,
	"./sugata_logo.png": 57,
	"./talksCardBack.svg": 180,
	"./talksCardBackAlt.svg": 181,
	"./tiktok_logo.png": 182,
	"./ui_ux_design.svg": 183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32;